import Vue from 'vue'
import VueNumerals from 'vue-numerals'

Vue.use(VueNumerals, {
  locale: 'pt-BR'
})
